<template>
    <div class="articles">
        <h1>Memoey's Magazin</h1>
        <div v-for="article in articles" :key="article.id">
          <p class="article_title"><router-link :to="{name:'articleEn', params:{ id: article.id}}">{{article.title}}</router-link></p>
        </div>
        <br>
        <router-link to="/">TOP Page</router-link>

        <!-- サイトマップ用 -->
        <!-- <div>
            <div v-for="article in articles" :key="article.id">
              &lt;url&gt;
              <br> &lt;loc&gt;
                https://translate.ameneko.com/article/en/{{article.id}}
                &lt;/loc&gt;   
              <br> &lt;/url&gt;
          </div>
        </div>  -->

    </div>
</template>

<script>
import axios from "axios";
// import moment from 'moment'
export default {
  components: {},
  data() {
    return {
      articles:'',
    };
  },
mounted() {
    this.fetchNotice();
    const title = "Magazin｜memoey"
    const description = "This is Magazin page"
    document.title = title
    document.querySelector("meta[property='og:title']").setAttribute('content', title)
    document.querySelector("meta[name='description']").setAttribute('content', description)
    document.querySelector("meta[property='og:description']").setAttribute('content', description)
},
  methods: {
    fetchNotice() {
      axios.get("https://translate.microcms.io/api/v1/articles_en?limit=10000", {
        headers: { "X-API-KEY": process.env.VUE_APP_MICRO_CMS }
      }).then(res => {
        this.articles = res.data.contents;
      }).catch(err => {
        console.log(err);
      });
    },
    // modifyDatetime(date) {
    //   return moment(date).locale('ja').format('LLL')
    // },
  },
};
</script>

<style scoped>
.articles{
  padding:20px;
}
h1{
  font-weight: bold;
  font-size: 1.2em;
  text-align: center;
  padding-bottom: 10px;
}
.article_title{
  font-size: 1.2em;
  padding:6px;
}
</style>